import React, { useEffect, useState } from 'react';
import {
  createVideoRelationByCourse,
  getAllVideoModules,
  getAllVideoModulesSubModules,
  getAllVideoonlySubmodules,
  getAllVideoRelationByCourse,
} from '../../../../service/admin/adminVideoes.service';
import MultiSearchableSelect from '../../../../components/form/MultiSearchableSelect';
import { SubmitHandler, useForm } from 'react-hook-form';
import formValidationRules from '../../../../helpers/formvalidationRules';
import FormButton from '../../../../components/button/FormButton';
import { toast } from 'react-toastify';
import { buildTree } from '../../../../components/tree/treeUtils';
import { TreeMain } from '../../../../components/tree/TreeMain';
import Loaders from '../../../../components/loaders/Loaders';
export default function AdminCourseVideoRelation(props: { id: string }) {
  const [fetchAllList, setFetchList] = useState<any>([]);
  const [fetchSubModuleList, setFetchSubModuleList] = useState<any>([]);
  const [defaultList, setDefaultList] = useState<any>([]);
  const [selectedModules, setSelectedModules] = useState([]);
  const [selectedSubModules, setSelectedSubModules] = useState([]);
  const [onlySubModules, setOnlySubModules] = useState<any>([]);
  const [allOnlySubModules, setAllOnlySubModules] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [treeData, setTreeData] = useState<any>([]);
  const [preSelectedIds, setPreSelectedIds] = useState<any>([]);
  const fetchModuleData = async () => {
    console.log("Step1 inti")
    let get: any = await getAllVideoModules();
    if (get?.status === 'success') {
      let data: any = [];
      get.message.map((item: any) => {
        data.push({ value: item.id, label: item.name });
      });
      console.log(data)
      setFetchList(data);
    }
  };
 
  const fetchSubModuleData = async (id: string) => {
    setLoading(true);
    let get: any = await getAllVideoModulesSubModules(id);
    if (get?.status === 'success') {
      let data: any = [];
      get.message.map((item: any) => {
        data.push({
          value: item.id,
          label: item.name,
          mod: item.fk_videoModule_id,
        });
      });

      // Merge with existing submodules, avoiding duplicates
      const mergedArray = [
        ...fetchSubModuleList,
        ...data.filter(
          (newItem: any) =>
            !fetchSubModuleList.some(
              (existingItem: any) => existingItem.value === newItem.value
            )
        ),
      ];
     
        setDefaultList((prevList:any) => [...prevList, ...mergedArray]);
     
      console.log(get?.message)
      const treeData = buildTree(get.message);
      console.log(treeData) 
      console.log(fetchAllList)
      setFetchSubModuleList((prev: any[]) => {
        console.log("s1") 
        console.log(fetchAllList)
        const newModule = fetchAllList.find((i: any) => i.value === id);
        if (!newModule) return prev;
      
        const updated = [...prev];
        const index = updated.findIndex((item) => item.module === newModule.label);
      
        const newEntry = {
          module: newModule.label,
          treeData: treeData
        };
      
        if (index > -1) {
          // Replace existing
          updated[index] = newEntry;
        } else {
          // Add new
          updated.push(newEntry);
        }
      
        return updated;
      });
      setLoading(false);
    }
    setLoading(false);
  };

  const fetchOnlySubmodules = async () => {
    setLoading(true);
    let get: any = await getAllVideoonlySubmodules();
    if (get?.status === 'success') {
      let data: any = [];
      get.message.map((item: any) => {
        data.push({ value: item.id, label: item.name });
      });
      setAllOnlySubModules(data);
      setLoading(false);
    }
    setLoading(false);
  };

  const getSelectedData = async (id: string) => {
    setLoading(true);
    let get: any = await getAllVideoRelationByCourse(id);
    if (get?.status === 'success') {
      if (get?.message.length > 0) {
        let getmod: string[] = [];
        let selectedSub = [];
        let selesub: any = [];
        let onlySub: any = [];
        let sendMesage:any = [];
        let activeMods:any = [];
        get?.message.map((e: any) => {
          sendMesage.push(
            e?.videoSubModule?.id
          )
          activeMods.push(e.fk_videoModule_id)
          getmod.push(e.fk_videoModule_id);
          selectedSub.push(e.fk_videoSubModule_id);
          if (e.videoModule?.videoSubModule?.length > 0) {
            e.videoModule.videoSubModule.map((it: any) => {
              selesub.push({
                label: it.name,
                value: it.id,
                mod: e.fk_videoModule_id,
              });
            });
          }
          if (e.fk_videoModule_id === null) {
            onlySub.push(e?.videoSubModule?.id);
          }
        });
        const uniqMod:any = [...new Set(activeMods)];
        console.log("uniqMod")
        console.log(uniqMod)
         setSelectedModules(uniqMod);
        for(let i=0;i<uniqMod.length;i++){
         await fetchSubModuleData(uniqMod[i])
        }
        let uniPreSelectedId = [...new Set(sendMesage)]
        setPreSelectedIds(uniPreSelectedId)
        // const uniqueArray: any = [...new Set(getmod)];
        
        // const uniqueArray1 = selesub.reduce((acc: any, current: any) => {
        //   const x = acc.find((item: any) => item.value === current.value);
        //   if (!x) {
        //     acc.push(current);
        //   }
        //   return acc;
        // }, []);
        // setOnlySubModules(onlySub);
        // // setFetchSubModuleList(uniqueArray1);
        // setSelectedSubModules(
        //   get?.message.map((item: any) => item.fk_videoSubModule_id)
        // );
      }
      setLoading(false);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchModuleData();
    fetchOnlySubmodules();
  }, [props.id]);
  
  useEffect(() => {
    if (fetchAllList.length > 0) {
      getSelectedData(props.id);
    }
  }, [fetchAllList, props.id]);

  const { handleSubmit, control } = useForm<any>({
    values: {
      modules: selectedModules ? selectedModules : [],
      sub_modules: selectedSubModules ? selectedSubModules : [],
      ony_submodules: onlySubModules ? onlySubModules : [],
    },
  });

  const onSubmit: SubmitHandler<any> = async (data: any) => {
    setLoading(true);
    let sendingData: any = [];
    let selectedSub:any = [];
    if (treeData.length > 0) {
      treeData.map((e: any) => {
        console.log("All submof")
        console.log(defaultList)
        console.log(defaultList.length)
        let filter: any = defaultList.filter((i: any) => i.value === e.id);
        if (filter.length > 0) {
          sendingData.push({
            fk_course_id: props.id,
            fk_videoModule_id: filter[0].mod,
            fk_videoSubModule_id: filter[0].value,
          });
          selectedSub.push(
            filter[0].value
          )
        }
      });
    }
    // if (data.ony_submodules.length > 0) {
    //   data.ony_submodules.map((e: any) => {
    //     sendingData.push({
    //       fk_course_id: props.id,
    //       fk_videoModule_id: null,
    //       fk_videoSubModule_id: e,
    //     });
    //   });
    // }
    console.log("sending data")
    console.log(sendingData)
    if(sendingData.length === 0){
      sendingData.push({
        fk_course_id: props.id,
        fk_videoModule_id: undefined,
        fk_videoSubModule_id: undefined,
      });
    }
    let cr = await createVideoRelationByCourse(sendingData);
    if (cr?.status === 'success') {
      setPreSelectedIds(selectedSub)
      toast.success('Course Video relation added successfully');
    }
    setLoading(false);
  };
  const handleModuleChange = async (e: any) => {
    console.log("init...")
      if(e.removed){
    let filteredList = fetchSubModuleList.filter((i:any) => i.mod !== e.removed);
      setFetchSubModuleList(filteredList);
      }
      if(e.selected.length === 0){
        setFetchSubModuleList([])
      }

    if (e.selected.length > 0) {
      if (e.removed) {
        let findExist = fetchAllList.filter((i: any) => i.value === e.removed);
        if (findExist.length > 0) {
          let filteredList = fetchSubModuleList.filter(
            (i: any) => i.mod !== e.removed
          );
          setFetchSubModuleList(filteredList);
        } else {
          fetchSubModuleData(e.selected[e.selected.length - 1]);
        }
      } else {
        fetchSubModuleData(e.selected[e.selected.length - 1]);
      }
    } else {
      setFetchSubModuleList([]);
    }
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className={`${fetchSubModuleList.length ===0  ? 'mb-[6rem]' : 'mb-5'}`}>
        <div className="mb-[1rem]">
          <MultiSearchableSelect
            name="modules"
            control={control}
            options={fetchAllList}
            label="Select Module"
            placeholder="Search.."
            onFetch={handleModuleChange}
          />
          {/* <MultiSearchableSelect
            name="sub_modules"
            control={control}
            options={fetchSubModuleList}
            label="Select Sub Module"
            placeholder="Search.."
          /> */}
        {
          loading ? <Loaders type='spinner' /> :
          fetchSubModuleList.length > 0 &&
          <>
          <p>Select Sub Module</p>
          <TreeMain trees={fetchSubModuleList} onFetch={setTreeData} preSelectedIds={preSelectedIds} />
          <FormButton loading={loading} title={`Submit`} />
          </>
        }
          
       
        </div>
      </form>
    </>
  );
}
